import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  AddressType,
  ContactRollType,
  CountryType,
  LanguageType,
  MaritalStatusType,
  RaceType,
  RelationType,
  ReligionType,
  StateType,
} from "./type/RegistrationDataType";
import {
  patientRegistrationModel,
  DocumentUploadType,
} from "./type/RegistrationModel";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
import { SaveDocumentPayloadType } from "../../../EMR/components/UploadDocuments/types";
const {clinicId} = getConstants()
const { patientRegistrationApi } = api;
export const getMaritalStatus = async (): Promise<
  ResponseType<MaritalStatusType[]>
> => {
  const result = await instance.get(patientRegistrationApi.maritalStatus);
  return result.data;
};

export const getLanguage = async (): Promise<ResponseType<LanguageType[]>> => {
  const result = await instance.get(patientRegistrationApi.languageApi);
  return result.data;
};

export const getRace = async (): Promise<ResponseType<RaceType[]>> => {
  const result = await instance.get(patientRegistrationApi.raceApi);
  return result.data;
};

export const getAddressType = async (): Promise<
  ResponseType<AddressType[]>
> => {
  const result = await instance.get(patientRegistrationApi.addressTypeApi);
  return result.data;
};

export const getCountry = async (): Promise<ResponseType<CountryType[]>> => {
  const result = await instance.get(patientRegistrationApi.countryApi);
  return result.data;
};

export const getStates = async (
  stateId: number
): Promise<ResponseType<StateType[]>> => {
  const result = await instance.get(
    `${patientRegistrationApi.stateApi}${stateId}?clinicId=${clinicId}`
  );
  return result.data;
};

export const getReligion = async (): Promise<ResponseType<ReligionType[]>> => {
  const result = await instance.get(patientRegistrationApi.religonApi);
  return result.data;
};

export const getContactTypes = async (): Promise<
  ResponseType<ContactRollType[]>
> => {
  const result = await instance.get(
    `${patientRegistrationApi.getContactTypes}${clinicId}`
  );
  return result.data;
};

export const getRelations = async (): Promise<ResponseType<RelationType[]>> => {
  const result = await instance.get(
    `${patientRegistrationApi.getRelations}${clinicId}`
  );
  return result.data;
};

export const saveRegisration = async (
  data: patientRegistrationModel
): Promise<ResponseType<string>> => {
  console.log(data);
  const result = await instance.post(patientRegistrationApi.saveApi, data);
  return result.data;
};

export const registerPatient = async (
  body: patientRegistrationModel & { 
    bookingId: number | null | undefined;
    documents?: DocumentUploadType[];
  }
): Promise<
  ResponseType<{
    patientMasterId: number;
    patientId: string;
    status: "success" | "fail";
  }>
> => {
  const formData = new FormData();
  if (body.addressMasterDto.uploadFile) {
    formData.append("file", body.addressMasterDto.uploadFile || "");
    body.addressMasterDto.uploadFile = ""
  }
  if (body.documents && body.documents.length > 0) {
    body.documents.forEach((doc) => {
      if (doc.file) {
        formData.append("files", doc.file);
        formData.append("doctype", doc.documentType || "");
      }
    });
  }
  formData.append("data", JSON.stringify(body));
  const result = await instance.post(patientRegistrationApi.save, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result.data;
};

export const getDocumentTypes = async (): Promise<ResponseType<any[]>> => {
  const result = await instance.get(`${api.emr.getDocumentTypes}${clinicId}`);
  return result.data;
};

export const saveDocumentService = async (
  params: SaveDocumentPayloadType
): Promise<ResponseType<any>> => {
  const { details, file } = params;
  const data = JSON.stringify({
    ...details,
    clinicId,
    createdById:1,
  });
  const formData = new FormData();
  formData.append("data", data);
  formData.append("file", file);
  const result = (await instance.post(api.emr.saveDocument, formData)).data;
  return result;
};

export interface ExistingDocumentType {
  id: number | string;
  documentType: string;
  fileName: string;
  filePath: string;
  url:string
}

export const getUploadedDocuments = async (
  emrno: string
): Promise<ResponseType<ExistingDocumentType[]>> => {
  const result = await instance.get(
    `${api.patientRegistrationApi.getUploadedDocuments}${emrno}`
  );
  return result.data;
};
export const deleteUploadedDocument = async (
  id: number | string
): Promise<ResponseType<any>> => {
  const result = await instance.delete(
    `${api.patientRegistrationApi.deleteUploadedDocument}${id}`
  );
  return result.data;
};
